import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetUploadLinksCountForProjectQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
  projectId: Types.Scalars['ID']['input'];
  page: Types.PageInput;
  filter?: Types.InputMaybe<Types.UploadLinksFilterInput>;
}>;


export type GetUploadLinksCountForProjectQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, project?: { __typename?: 'Project', id: string, uploadLinks?: { __typename?: 'UploadLinkConnection', totalCount: number } | null } | null } | null };


export const GetUploadLinksCountForProject = /*#__PURE__*/ gql`
    query GetUploadLinksCountForProject($accountId: ID!, $projectId: ID!, $page: PageInput!, $filter: UploadLinksFilterInput) @stewardship(stewards: [VIEWER]) {
  account(by: {id: $accountId}) {
    id
    project(id: $projectId) {
      id
      uploadLinks(page: $page, filter: $filter) {
        totalCount
      }
    }
  }
}
    ` as unknown as DocumentNode<GetUploadLinksCountForProjectQuery, GetUploadLinksCountForProjectQueryVariables>;

          

          export const useGetUploadLinksCountForProjectQuery = (options?:QueryHookOptions<GetUploadLinksCountForProjectQuery, GetUploadLinksCountForProjectQueryVariables>) => useQuery(GetUploadLinksCountForProject, options);

          

          export type GetUploadLinksCountForProjectQueryOptions = QueryHookOptions<GetUploadLinksCountForProjectQuery, GetUploadLinksCountForProjectQueryVariables>;

          

          export const useGetUploadLinksCountForProjectLazyQuery = (options?:LazyQueryHookOptions<GetUploadLinksCountForProjectQuery, GetUploadLinksCountForProjectQueryVariables>) => useLazyQuery(GetUploadLinksCountForProject, options);

          

          export type GetUploadLinksCountForProjectQueryResult = ReturnType<typeof useGetUploadLinksCountForProjectQuery>;

          
